import { call, options, params } from './helpers';

export const getConsumables = (payload) =>
	call(`/beta/consumables${params(payload)}`, null, null, {
		...(payload?.export ? { csvResponse: true } : {}),
	});

export const addConsumable = (payload) =>
	call(`/beta/consumables`, options(payload, 'POST'));

export const getConsumable = ({ id }) => call(`/beta/consumables/${id}`);
export const updateConsumable = ({ id, ...payload }) =>
	call(`/beta/consumables/${id}`, options(payload, 'PUT'));

export const deleteConsumable = (id) =>
	call(`/beta/consumables/${id}`, options(null, 'DELETE'));
